import axios from 'axios';
import axiosRetry from 'axios-retry';

// This retries if it is a 5xx error
axiosRetry( axios, { retries: 3 }) ;

let BaseURL = '$SERVER_URL/api/v1';

if (process.env.NODE_ENV === 'development') {
  BaseURL = 'http://localhost:3000/api/v1';
}

export const client = axios;

export const baseURL = BaseURL;

export default function (options = {}) {
  const { headers = {}, timeout = 60000 } = options;

  return client.create({
    baseURL,
    timeout,
    headers,
  })
};